/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { css, jsx } from '@emotion/react'
import { FormattedMessage } from 'react-intl'

import { EuiCodeBlock, EuiFormLabel, EuiSpacer } from '@elastic/eui'

import type { ApiKeyResponse } from '@modules/cloud-api/v1/types'
import { CuiAlert } from '@modules/cui/Alert'

import GeneratedApiKeyFooter from './GeneratedApiKeyFooter'
import messages from './messages'

import type { FunctionComponent } from 'react'

type Props = {
  apiKey: ApiKeyResponse
}

const GeneratedApiKey: FunctionComponent<Props> = (props) => {
  const { apiKey } = props
  const { key } = apiKey

  return (
    <div>
      <CuiAlert type='success' size='s'>
        <FormattedMessage {...messages.generatedApiKeyWarning} />
      </CuiAlert>

      <EuiSpacer size='m' />

      <EuiFormLabel>
        <FormattedMessage {...messages.generatedKey} />
      </EuiFormLabel>

      <EuiSpacer size='xs' />

      <EuiCodeBlock paddingSize='s' isCopyable={true} css={css({ overflowWrap: 'break-word' })}>
        {key}
      </EuiCodeBlock>

      <EuiSpacer size='m' />

      <GeneratedApiKeyFooter apiKey={apiKey} />
    </div>
  )
}

export default GeneratedApiKey
